import React from 'react';
import { useTranslation } from 'react-i18next';

import LoginWithName from '../LoginWithName/LoginWithName';

import styles from './LoginAdminDesktop.module.scss';

function LoginAdminDesktop(): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.fieldsetTitle}>
        <span>{t('LABEL_ALREADY_ORDERED')}</span>
      </div>
      <div className={styles.loginContainer}>
        <LoginWithName />
      </div>
    </div>
  );
}

export default LoginAdminDesktop;
